//import { Tc, PagingResultsViewModel } from "../../../core/_infrastructure/types/common";
import { PagingResultsViewModel, FilterSearchingBaseViewModel, EnumSiNoTodos } from "../../../core/_infrastructure/types/common";

//export class CodigoEppoItemResultsViewModel extends PagingResultsViewModel {

//    public ResultList: CodigoEppoViewModel [];
//}

// ****
// *** Se ha trasladado a common.ts por ser de uso común para Mantenimiento, codigoEppoPopup, nombrecientifico ***\\\
// ***

//export class CodigoEppoViewModel {

//    constructor()
//    {
        
//    }
    
//    public Id: number;    
//    public CodigoEppo: string = '';
//}

export class FilterSearchingCodigoEppoViewModel extends FilterSearchingBaseViewModel {    

    public CodigoEppo: string = '';
    public InvasivaNoPermitida: number = EnumSiNoTodos.TODOS;
}



